<template>
  <div v-show="isOpen">
    <div class="page-overlay">
      <div class="overlay-lightbox" :class="{ center: popupAlignment === 'center' }">
        <div class="overlay-content">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PageOverlay',
  props: {
    isOpen: Boolean,
    popupAlignment: {
      type: String,
      default: 'start',
      validator: val => ['start', 'center'].includes(val),
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../node_modules/base-ui/src/scss/riseup-colors';
@import '../scss/mixins';

.page-overlay {
  width: 100%;
  height: 100%;
  position: fixed; // TODO add somthing from elsa that disable scroll from background
  display: flex;
  justify-content: center;

  .overlay-lightbox {
    @include responsive-padding;
    @include responsive-padding-top-bottom;
    background-color: rgba(43, 50, 59, 0.84);
    font-family: SimplerPro;
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    text-align: center;
    overflow-y: auto;
    scroll-behavior: smooth;
    display: flex;
    align-items: flex-start;

    &.center {
      align-items: center;
    }

    .overlay-content {
      width: 100%;
      display: inline-block;
      background: $riseup_white;
      border-radius: 3px;
      box-shadow: 0 0 6px 0 $riseup_gray_1;
    }
  }
}

@media (min-width: 430px) {
  .page-overlay {
    width: 100%;
    display: flex;
    justify-content: center;

    .overlay-lightbox {
      width: 400px;
      height: calc(100vh - 100vh*0.1 - 35px - 20px);
      margin: calc(100vh*0.05) 0;
    }
  }
}
</style>
